module.exports = "<h1 class=\"page-heading\">\n  {{ title }}\n</h1>\n\n<div >\n<h1 class=\"text-dark-yellow margin-none\">{{ title }} Coming Soon ...</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recent-licenses/recent-licenses.component.html
// module id = ./src/app/recent-licenses/recent-licenses.component.html
// module chunks = main